import {DolphinAPIClientProvider} from "@amzn/dolphin-web-framework";
import {getNodeInductServiceBaseURL} from "./BaseURLUtils";
DolphinAPIClientProvider.generateDolphinAPIClient(getNodeInductServiceBaseURL());
const axiosNISClient = DolphinAPIClientProvider.dolphinAPIClient;
export default axiosNISClient;